<template>
  <div class="mother-tree-wrapper" v-loading="loadTree">
    <div id="mother" class="mother-tree-container">
      <!-- <canvas id="canvasForMother"></canvas> -->
    </div>
  </div>
</template>
<script>
import { apiMap } from "../../../utils/apiMap";
import _ from "lodash";
import dTree from "../../../utils/dTree";
import * as d3 from "d3";
export default {
  name: "mother-tree",
  data() {
    return {
      loadTree: true,
      boxWidth: 80,
      boxHeight: 30,
      fatherDivPad: 30,
      fatherDivWidth: 832,
      fatherDivHeight: 92,
      motherDivWidth: 832,
      motherDivHeight: 92,
      boxMargin: 11,
      mateScale: 15,
      husbandScale: 2,
      parentPosition: {},
      Ancestors: {},
      Descendant: {},
      copyMark: {},
      liveUser: {},
      treeData: {},
      personMap: {},
      svgStyle: {
        height: 600,
        width: 840,
      },
    };
  },
  created() {
    this.getFamilyTree();
  },
  methods: {
    beArray(arr) {
      return arr instanceof Array;
    },
    getFamilyTree() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["motherTree"]["method"],
          url: apiMap["motherTree"]["url"],
          params: {
            token: loginUser.token,
          },
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.treeData = response.data.result.data;
            _this.loadTree = false;
            _this.initTreeData(_this.treeData, 1);
            _this.initTreeWithD3(_this.treeData);
            _this.setMeCenter();
          } else {
            _this.$message({
              message: "暂无家谱，快去与好友传连吧",
              duration: 1500,
              offset: 230,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    setMeCenter() {
      let meNode = document.querySelector(".is-me");
      if (!meNode.parentNode) {
        return;
      }
      let parNode = meNode.parentNode;
      let nodeX = parNode.getAttribute("x").slice(0, -2);
      let nodeY = parNode.getAttribute("y").slice(0, -2);
      const NumExp = /^(\-|\+)?\d+(\.\d+)?$/;
      if (!document.querySelector("#mother")) {
        return;
      }
      let svgNode = document.querySelector("#mother").children[0].children[0];
      // console.log(svgNode.getAttribute("transform").split(" "));
      let transformVal = svgNode.getAttribute("transform").split(" ");
      let translateAttr = transformVal[0];
      // let originScale = transformVal[1];
      let bracketS = translateAttr.indexOf("(") + 1;
      let bracketE = translateAttr.lastIndexOf(")");
      let aimStr = translateAttr.slice(bracketS, bracketE);
      let originTsf = aimStr.split(",");
      if (NumExp.test(nodeX) && NumExp.test(nodeY)) {
        // console.log(Number(nodeX), Number(nodeY));
        if (NumExp.test(originTsf[0]) && NumExp.test(originTsf[1])) {
          // console.log(Number(originTsf[0]));
          // let diffHeight = this.svgStyle.height-Number(nodeY);
          let newWidth = Number(originTsf[0]) - Number(nodeX) - 40;
          let halfDiffH = this.svgStyle.height / 2 - Number(nodeY);
          let newHeight = Number(originTsf[1]) - 11 + halfDiffH;
          // console.log(Number(originTsf[1]) - 11 + halfDiffH);
          // console.log(newHeight);
          // let newVal = `translate(${newWidth},${newHeight}) ${originScale}`;
          // console.log(newVal);
          // svgNode.setAttribute("transform", newVal);
          this.runToPosition(newWidth, newHeight);
        }
      } else {
        console.log("x,y 属性不符合数字类型");
      }
    },
    runToPosition(x, y) {
      // create zoom handler
      const zoom = d3
        .zoom()
        .scaleExtent([0.1, 10])
        .on("zoom", function() {
          g.attr("transform", d3.event.transform);
        });

      // create a svg
      const svg = d3.select("svg").call(zoom);

      // create svg group that holds all nodes
      const g = d3.select(svg._groups[0][0].children[0]);

      // set zoom identity
      svg.call(zoom.transform, d3.zoomIdentity.translate(x, y).scale(1));
    },
    initTreeWithD3(treeData) {
      let _this = this;
      dTree.init(treeData, {
        target: "#mother",
        debug: true,
        hideMarriageNodes: true,
        marriageNodeSize: 5,
        height: _this.svgStyle.height,
        width: _this.svgStyle.width,
        callbacks: {
          nodeClick: function(name, userId) {
            // alert('左击: ' + name);
            _this.initPersonClick(userId);
          },
          // nodeRightClick: function(name, extra) {
          // 	alert('右击: ' + name);
          // },
          textRenderer: function(name, extra, textClass) {
            if (extra && extra.nickname)
              name = name + " (" + extra.nickname + ")";
            return (
              "<p align='center' class='" + textClass + "'>" + name + "</p>"
            );
          },
          marriageClick: function(extra, id) {
            alert("Clicked marriage node" + id);
          },
          marriageRightClick: function(extra, id) {
            alert("Right-clicked marriage node" + id);
          },
        },
      });
    },
    initTreeData(data, generation) {
      let _this = this;
      var userKey = data.userId;
      _this.personMap[userKey] = {
        userId: userKey,
        userName: data.userName,
        sex: data.sex,
        generation: generation,
        mate: false,
        copyFlag: data.copyFlag,
        status: data.status,
      };

      for (var p = 0; p < data.partners.length; p++) {
        var spouseId = data.partners[p].userId;
        // var status = data.partners[p].status;

        _this.personMap[spouseId] = {
          userId: spouseId,
          userName: data.partners[p].userName,
          sex: data.partners[p].sex,
          generation: generation,
          mate: true,
          copyFlag: 0,
          status: data.partners[p].status,
        };
      }

      generation++;
      if (data.partnerPublicChildren.length !== 0) {
        for (var i = 0; i < data.partnerPublicChildren.length; i++) {
          var orderedChildren = data.partnerPublicChildren[i];
          for (var j = 0; j < orderedChildren.length; j++) {
            if (orderedChildren[j]) {
              _this.initTreeData(orderedChildren[j], generation);
            }
          }
        }
      }
    },
    initPersonClick(userId) {
      // console.log(this.personMap);
      // console.log(this.personMap[userId]);
      let userBrief = this.personMap[userId];
      if (userBrief) {
        var clickTime = Math.round(new Date() / 1000);
        var userInfo = {
          clickTime: clickTime,
          dataCopy: userBrief["copyFlag"],
          dataGene: userBrief["generation"],
          name: userBrief["userName"],
          mate: userBrief["mate"],
          sex: userBrief["sex"],
          userId: userId,
          treeType: "2",
          userType: userBrief["status"],
        };
        //临时节点
        if (userBrief["status"] == "1") {
          return false;
        }
        this.$bus.$emit("switch-tree-profile", userInfo);
      }
    },
  },
};
</script>
<style>
.mother-tree-wrapper {
  min-height: 60px;
  padding: 2px;
}

.tree-container {
  position: relative;
  text-align: center;
  overflow: auto;
}

#canvasForMother {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}

.tree-container .child_box {
  width: 832px;
  position: relative;
  height: 32px;
  padding: 30px 0;
  margin: 0 auto;
  white-space: nowrap;
  z-index: 3;
}

.tree-container div a {
  display: inline-block;
  width: 80px;
  height: 30px;
  margin: 0 10px;
  font-size: 14px;
  border: 1px solid #000000;
  border-radius: 5px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 30px;
  color: #333333;
}

.tree-container div a.is_me {
  color: #fb6161;
}
</style>
